import io from "socket.io-client";

export const socket = io(`${process.env.REACT_APP_SOCKET_API}`, {
  transports: ["websocket"],
  reconnectionDelay: 5000,
  reconnection: true,
  autoConnect: false,
});
